// Draw text to canvas, determine line break position, and set canvas height
const canvasWrapText = (options: { [key: string]: any }) => {
  // Sometimes the set text is not fully displayed, and you need to carefully explore the line height, and the relationship between the starting y coordinate of drawing and the font size. a simpler and more crude way is to assign more points when assigning canvas.height below.
  const settings: any = {
    canvas: document.createElement('canvas'), // canvas object, required. if not filled in, one will be created by default.canvas
    canvasWidth: 9000, // canvas width
    canvasMinHeight: 60, // canvas the minimum height of0
    drawStartX: 0, // Draw the starting x coordinate of the string
    drawStartY: 0, // Draw the starting y coordinate of the string
    lineHeight: 0, // Line height of text
    font: "30px 'Great Vibes', cursive", // Text style
    text: 'Please modify the default configuration', // the text that needs to be drawn
    drawWidth: 9000, // Text display width
    color: '#000000', // Text color
    backgroundColor: '#ffffff' // Background color
  }

  // Overwrite the default configuration with the incoming configuration
  if (!!options && typeof options === 'object') {
    for (const i in options) {
      settings[i] = options[i]
    }
  }

  // Get the online text of 2d and start setting related attributes
  const canvas = settings.canvas
  //  canvas.width = settings.canvasWidth;
  const ctx = canvas.getContext('2d')

  // Draw text
  ctx.font = settings.font
  ctx.fillStyle = settings.color
  let lineWidth = 0 // The drawn width of the current line
  let lastTextIndex = 0 // The subscript of the last character on the canvas has been drawn
  // Since changing the height of the canvas will cause the drawn texture to be cleared, it is not pre-drawn but put into an array first.
  const arr = []
  for (let i = 0; i < settings.text.length; i++) {
    // Get the width of the current intercepted string
    lineWidth = ctx.measureText(settings.text.substr(lastTextIndex, i - lastTextIndex)).width

    if (lineWidth > settings.drawWidth) {
      // Determine whether the last digit is a punctuation mark
      if (judgePunctuationMarks(settings.text[i - 1])) {
        arr.push(settings.text.substr(lastTextIndex, i - lastTextIndex))
        lastTextIndex = i
      } else {
        arr.push(settings.text.substr(lastTextIndex, i - lastTextIndex - 1))
        lastTextIndex = i - 1
      }
    }
    // Add the last extra part to the array
    if (i === settings.text.length - 1) {
      arr.push(settings.text.substr(lastTextIndex, i - lastTextIndex + 1))
    }
  }

  // Set the width of the canvas based on the width of the string
  canvas.width = lineWidth

  // Set the height of canvas according to the length of arr
  canvas.height = arr.length * settings.lineHeight
  // Determine whether the minimum height is reached
  if (canvas.height < settings.canvasMinHeight) {
    // Reset starting position
    settings.drawStartY += (settings.canvasMinHeight - canvas.height) / 2
    canvas.height = settings.canvasMinHeight
  }

  // Draw background color
  ctx.fillStyle = settings.backgroundColor
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  // Set font color
  ctx.font = settings.font
  ctx.textBaseline = 'middle'
  ctx.fillStyle = settings.color
  for (let i = 0; i < arr.length; i++) {
    ctx.fillText(arr[i], settings.drawStartX, settings.drawStartY + i * settings.lineHeight)
  }

  // Determine whether it is a label symbol that needs to be avoided
  function judgePunctuationMarks(value: string) {
    const arr = ['.', ',', ';', '?', '!', ':', '"', ',', '.', '? ', '! ', '; ', ': ', ', ']
    for (let i = 0; i < arr.length; i++) {
      if (value === arr[i]) {
        return true
      }
    }
    return false
  }
  return canvas.toDataURL()
}
const dataURLtoFile = (dataurl: string, filename: string) => {
  const arr = dataurl.split(',')
  const mime = (arr[0] as any).match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}
export { canvasWrapText, dataURLtoFile }
